import { Directive, ElementRef, Input, OnInit } from '@angular/core'

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[data-preview-id]'
})
export class MbDataPreviewIdDirective implements OnInit {

  @Input('data-preview-id') dataPreviewId: string | null | undefined = ''

  constructor (private el: ElementRef) {
  }

  ngOnInit (): void {
    let previewId = this.dataPreviewId?.replaceAll('undefined', '').replaceAll('null', '').trim()
    if (previewId === '#') {
      previewId = ''
    }
    this.el.nativeElement.removeAttribute('ng-reflect-data-preview-id')
    if (previewId) {
      this.el.nativeElement.setAttribute('data-preview-id', previewId)
    }
  }
}
